// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"71":"1ec2b28f4c53976961a3","5935":"86346c530d14713c7033"}[chunkId] + ".js";
};